import { formatInTimeZone } from 'date-fns-tz';

export const formatScheduledDate = (date: Date): string => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formatted = formatInTimeZone(date, timeZone, "MMM d yyyy' · 'h:mmaaa");

  const timeZoneName =
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    })
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value ?? '';

  return `${formatted} ${timeZoneName}`;
};
